<template>
  <div class="wechat-list">
    <div class="tableConBox">
      <div class="tableTem">
        <div class="HSpace1"></div>
        <div class="searchBox flex flex-align-center">
          <div class="searchCon clearfix">
            <div class="left searchBtn" style="margin-left: 10px">
              <button type="button" @click="codeBtn = true">
                添加通知微信
              </button>
            </div>
          </div>
        </div>
        <div class="HSpace2">&nbsp;</div>
        <div class="tableBox">
          <div class="tableBoxScroll">
            <table class="titleTable">
              <tr>
                <th style="width: 8%">序号</th>
                <th style="width: 11%">姓名</th>
                <th style="width: 11%">添加时间</th>
                <th style="width: 10%">操作</th>
              </tr>
            </table>
            <div class="scrollBox">
              <div class="scroll">
                <table
                  class="conTable"
                  :class="{ overLengthTable: wechatList.length > pageSize }"
                >
                  <tr
                    v-for="(item, index) in wechatList"
                    :key="index"
                    class="listTr"
                  >
                    <td style="width: 8%">{{ item.id ? index + 1 : "" }}</td>
                    <td style="width: 11%">{{ item.name }}</td>
                    <td style="width: 13%" v-if="false">
                      <img
                        :src="item.image"
                        alt=""
                        :style="item.id ? 'width:50px;height:50px;' : ''"
                      />
                    </td>
                    <td style="width: 11%">
                      {{ item.addTime | dateForGradePage }}
                    </td>
                    <td style="width: 10%">
                      <!-- <span :class="item.enabled?'do-active':'do-active not-active'" @click="doActive(item)">{{item.id?"删除":""}}</span> -->
                      <span
                        :title="'删除'"
                        :class="
                          item.enabled ? 'do-active' : 'do-active not-active'
                        "
                        @click="doActive(item)"
                        ><i
                          v-if="item.id"
                          style="color: #333"
                          class="iconfont icon-icon1460188478041"
                        ></i
                      ></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="'请打开微信扫描二维码'"
      class="codes"
      :visible.sync="codeBtn"
      v-loading.body="infoload"
      size="tiny"
    >
      <!-- <div style="color:red;margin-top:10px;font-size:12px;text-align:center;position:absolute;top:8px;left:7em;" v-if="!isSendCodeBtn">
                <span >验证码已发送到老板手机号</span>
            </div> -->
      <div style="color: red; font-size: 12px; text-align: center">
        <span>输入姓名后，点按回车键并扫描二维码</span>
      </div>
      <div style="text-align: center; padding-top: 15px">
        <form @submit.prevent="doShowQrcode">
        <el-input
          style="width: 250px"
          v-model="name"
          placeholder="请输入姓名"
          type="text"
        />
        </form>
      </div>
      <div class="inners" v-if="showQrCode">
        <div id="qrcode"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
export default {
  props: ["curStoreId", "pageSize", "storeData"],
  data() {
    return {
      name: null,
      showQrCode: false,
      wechatList: [],
      infoload: false, // loading
      codeBtn: false,
    };
  },
  watch: {
    name(val) {
        this.showQrCode = false;
      if (!val) {
        this.showQrCode = false;
      }
    },
    codeBtn(val) {
      if (!val) {
        this.name = null;
        this.showQrCode = false;
      }
    },
  },
  methods: {
    doShowQrcode() {
      this.showQrCode = false;
      this.getWechatCode();
    },
    doActive(item) {
      this.$confirm(
        "此操作将删除该微信绑定, 该微信将无法收到相关推送消息?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$http({
            url: "/open-enabled",
            method: "GET",
            params: {
              id: item.id,
              enabled: item.enabled ? false : true,
            },
          }).then((res) => {
            this.$message({
              message: "操作成功",
              customClass: "success",
            });
            this.getWechatList();
          });
        })
        .catch(() => {});
    },
    getWechatCode() {
      this.showQrCode = false;
      this.$http({
        url: "/openId",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          name: this.name,
        },
      }).then((res) => {
        this.showQrCode = true;
        setTimeout(() => {
          $("#qrcode")[0].innerHTML = "";

          let qrcode = new QRCode("qrcode", {
            text: res.data,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
        }, 900);
      });
    },
    getWechatList() {
      this.$http({
        url: "/open-notice",
        method: "GET",
        params: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        this.wechatList = res.data;
        let number = this.pageSize - this.wechatList.length;
        if (number > 0) {
          for (let i = 0; i < number; i++) {
            this.wechatList.push({});
          }
        }
      });
    },
  },
  created: function () {
    for (let i = 0; i < this.pageSize; i++) {
      this.wechatList.push({});
    }

    this.getWechatList();
  },
  mounted: function () {
    // 改变关闭样式
    $(document).ready(() => {
      $(".el-dialog__headerbtn i").attr(
        "class",
        "el-dialog__close iconfont icon-guanbi"
      );
    });
  },
};
</script>
<style lang="scss">
@import "../../../../static/css/common.scss";
@import "../../tableTemplate/tableTem.scss";
@import "../../tableTemplate/el-dialog.scss";
@import "./wechatList.scss";
</style>



// WEBPACK FOOTER //
// wechatList.vue?40dd4ad6